import React, { useState, useEffect } from 'react';

const Carousel = ({ imageUrls = [], style }) => {
  const [activeIndex, setIndex] = useState(0);
  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      if ((activeIndex + 1) !== imageUrls.length) {
        setIndex(activeIndex + 1);
      } else {
        setIndex(0);
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [activeIndex]);
  return (
    <div className="carousel slide">
      <ol className="carousel-indicators">
        {imageUrls.map((item, index) => {
          const key = `${item?.id || ''}-${index}`;
          return <li key={key} role="presentation" onClick={(e) => { e.stopPropagation(); setIndex(index); }} className={index === activeIndex ? 'active' : ''} />;
        })}
      </ol>
      <div className="carousel-inner">
        {imageUrls.map((item, index) => {
          const key = `${item?.id || ''}-${index}`;
          return (
            <div key={key} className={index === activeIndex ? 'carousel-item active' : 'carousel-item'}>
              <img className={style.imageSize} src={item} alt="" style={{ objectFit: 'cover' }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Carousel;
